import { useState } from "react";
import { rutaIcono } from "../lib/iconosIlustrados";

/**
 * Icono ilustrado del set de contenido (ver `lib/iconosIlustrados.ts`).
 *
 * `loading="lazy"` porque el set es de PNG a 160 px: una materia con seis
 * unidades plegadas pide seis imágenes, y las que quedan bajo el corte pueden
 * esperar. Con el set vectorial anterior daba igual — a 3,5 KB no compensaba.
 *
 * Si el fichero falta, no se pinta nada. Es decoración que nombra contenido:
 * una materia no puede desaparecer porque falte un dibujo, y un recuadro roto
 * es peor que un hueco.
 */
export function IconoIlustrado({
  nombre,
  size = 40,
  className,
}: {
  nombre: string | undefined;
  size?: number;
  className?: string;
}) {
  const [falla, setFalla] = useState(false);
  if (!nombre || falla) return null;
  return (
    <img
      src={rutaIcono(nombre)}
      alt=""
      aria-hidden="true"
      loading="lazy"
      decoding="async"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain", display: "block", flex: "none" }}
      onError={() => setFalla(true)}
    />
  );
}
